module.exports = __webpack_public_path__ + "static/media/formNotif.ecadfc75.svg";